import { actionsStyles as styles } from "@bevco/Overrides/Widgets/ProductList/ProductListTable";
import { colorStrings, mediaQueriesBP } from "@bevco/Utilities/variables";
import { DataTableHeadProps } from "@insite/mobius/DataTable/DataTableHead";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.wrapper = {
    ...styles.wrapper,
    css: css`
        overflow: auto;
        ${mediaQueriesBP.minLG} {
            overflow: visible;
        }

        width: 100%;
    `,
};

styles.attributesHeader = {
    ...styles.attributesHeader,
    css: css`
        position: sticky;
        top: -1px;
        box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
        z-index: 1;

        ${({ theme }) => {
            const {
                header: { isCompactHeader },
            } = theme;
            return css`
                ${mediaQueriesBP.minLG} {
                    ${isCompactHeader &&
                    css`
                        top: 49px;
                    `}
                }
            `;
        }}

        &:hover {
            button {
                text-decoration: underline;
            }
        }
    `,
};

styles.dataTable = {
    ...styles.dataTable,
    css: css`
        .product-accordion-content {
            &[aria-hidden="false"] {
                display: table-row;
                background-color: ${getColor(colorStrings.commonGlobalWhite)} !important;
                border-bottom: 3px solid ${getColor(colorStrings.primaryMain)};
                border-inline: 3px solid ${getColor(colorStrings.primaryMain)};
                border-top: 0;
            }

            &[aria-hidden="true"] {
                display: none;
                border-bottom: 3px solid transparent;
                border-inline: 3px solid transparent;
                border-top: 0;
            }
        }

        .product-accordion-header {
            transition: all 0.2s ease-in-out;

            td,
            td span {
                font-size: 14px;
            }

            &.even {
                background: ${getColor(colorStrings.commonGlobalWhite)};
            }

            &.odd {
                background: ${getColor(colorStrings.commonGlobalGray05)};
            }

            &:hover:not([aria-expanded="true"]) {
                cursor: pointer;
                transform: scale(1.0009);
                box-shadow: 1px 2px 2px -1px rgba(0, 0, 0, 0.4);
            }

            &[aria-expanded="true"] {
                background-color: ${getColor(colorStrings.commonGlobalWhite)} !important;
                border-top: 3px solid ${getColor(colorStrings.primaryMain)};
                border-inline: 3px solid ${getColor(colorStrings.primaryMain)};
                border-bottom: 0;
            }

            &[aria-expanded="false"] {
                border-top: 3px solid transparent;
                border-inline: 1px solid transparent;
                border-bottom: 0;
            }
        }
    `,
};

styles.availabilityStatusText = {
    ...styles.availabilityStatusText,
    css: css`
        display: inline-flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        gap: 5px;
    `,
};

styles.cardContainerStyles = {
    cardDivider: {
        css: css`
            width: 100%;
            margin: 0;
            border: 0;
        `,
    },
    gridItem: {
        css: css`
            border-bottom: 0;
            padding: 0;
        `,
    },
};

styles.productListProductCardStyles = {
    ...styles.productListProductCardStyles,
    leftColumnGridItem: {
        ...styles.productListProductCardStyles?.leftColumnGridItem,
        width: [3, 3, 3, 2, 2],
        css: css`
            flex-direction: column;
        `,
    },
    rightColumnGridItem: {
        width: [9, 9, 9, 10, 10],
    },

    productListProductImageStyles: {
        productImage: {
            linkWrappingImage: {
                css: css`
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 100%;
                    max-height: 100px;

                    img {
                        max-height: 100px;
                        object-fit: contain;
                        aspect-ratio: 4/3 !important;
                    }
                `,
            },
        },
    },
};

styles.centeringWrapper = {
    css: css`
        width: 100%;
        height: 100px;
        display: flex;
        align-items: center;
        background-color: transparent !important;
    `,
};

styles.spinner = {
    css: css`
        margin: auto;
    `,
};
